import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ReactionType } from './../../models/clubs/reaction-type.model';
import { CacheService } from './../shared/cache.service';

@Injectable({
    providedIn: 'root',
})
export class ReactionTypeService {
    private readonly reactionTypeApiUrl = `${environment.microservices.clubs.baseUrl}/${environment.microservices.clubs.reactionTypeApi.baseUrl}`;
    private reactionTypesCacheKey = 'currentReactionTypesCacheKey';

    constructor(private http: HttpClient, private readonly cacheService: CacheService) {}

    getAllReactionTypes(): Observable<ReactionType[]> {
        return this.cacheService.get(this.reactionTypesCacheKey, this.http.get<ReactionType[]>(this.reactionTypeApiUrl));
    }
}
